import { c as _c } from "react/compiler-runtime";
import { clsx as cn } from "@/helpers/clsx";
import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
export const badgeVariants = cva("font-semibold text-xs rounded-md border px-2 py-1 !text-white leading-none [text-shadow:1px_1px_1px_rgba(0,0,0,0.3)]", {
  variants: {
    color: {
      green: "bg-emerald-600 border-emerald-400",
      yellow: "bg-yellow-600 border-yellow-400",
      red: "bg-red-600 border-red-400",
      blue: "bg-blue-600 border-blue-500",
      orange: "bg-orange-700 border-orange-500"
    }
  }
});
function getMethodColor(method: string): VariantProps<typeof badgeVariants>["color"] {
  switch (method.toUpperCase()) {
    case "PUT":
      return "yellow";
    case "PATCH":
      return "orange";
    case "POST":
      return "blue";
    case "DELETE":
      return "red";
    default:
      return "green";
  }
}
export function Badge(t0) {
  const $ = _c(10);
  let className;
  let color;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = color;
    $[3] = props;
  } else {
    className = $[1];
    color = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== color) {
    t1 = cn(badgeVariants({
      color,
      className
    }));
    $[4] = className;
    $[5] = color;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <span className={t1} {...props}>{props.children}</span>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export function MethodLabel(t0) {
  const $ = _c(11);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = getMethodColor(children);
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children) {
    t2 = children.toUpperCase();
    $[5] = children;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t3 = <Badge {...props} color={t1}>{t2}</Badge>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}